import { crud } from "../../../app/crud";
import { selector } from "./selector";

const displayCameraFeed = function () {
    const $videoModal = $(selector.videoModal);
    const videoPlayer = $(selector.videoPlayer)[0];
    const $videoPlayer = $(selector.videoPlayer);
    const $imagePlayer = $(selector.imagePlayer);
    const modal = new bootstrap.Modal($videoModal[0]);
    const url = $(this).data("url");

    videoPlayer.pause();
    videoPlayer.src = "";
    $videoPlayer.hide();
    $imagePlayer.attr("src", "").hide();

    if (!url.endsWith(".m3u8")) {
        $imagePlayer.attr("src", url).show();
    } else {
        $videoPlayer.show();

        if (Hls.isSupported()) {
            const hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(videoPlayer);
        } else if (videoPlayer.canPlayType("application/vnd.apple.mpegurl")) {
            videoPlayer.src = url;
        }

        videoPlayer.play();
    }

    modal.show();
}

const pauseCameraFeed = function () {
    const $videoModal = $(selector.videoModal);
    const videoPlayer = $(selector.videoPlayer)[0];
    const $videoPlayer = $(selector.videoPlayer);
    const $imagePlayer = $(selector.imagePlayer);
    const modal = new bootstrap.Modal($videoModal[0]);
    videoPlayer.pause();
    videoPlayer.src = "";
    $videoPlayer.hide();
    $imagePlayer.attr("src", "").hide();
}


export { displayCameraFeed, pauseCameraFeed };